export const CREATE_GOODSRECEIVED26115 = "CREATE_GOODSRECEIVED26115";
export const UPDATE_GOODSRECEIVED26115 = "UPDATE_GOODSRECEIVED26115";
export const DELETE_GOODSRECEIVED26115 = "DELETE_GOODSRECEIVED26115";
export const FETCH_GOODSRECEIVED26115 = "FETCH_GOODSRECEIVED26115";
export const LISTEN_TO_SELECTED_GOODSRECEIVED26115 =
  "LISTEN_TO_SELECTED_GOODSRECEIVED26115";
